import React, { type FC, createContext, useContext, useEffect, useState, useCallback } from 'react';
import * as mqtt_instance from '@src/Main/mqtt_instance';

import { messageBox } from '@src/style/style';

const REMOTE_ACCESS_TOPIC = 'machine-cloud/remote-access';
const REMOTE_ACCESS_FAILED_TOPIC = 'machine-cloud/remote-access-failed';

interface RemoteAccessContextData {
  remoteAccessEnabled: boolean
  requestRemoteAccess: (_state: boolean) => void
}

const RemoteAccessContext = createContext<RemoteAccessContextData>({
  remoteAccessEnabled: false,
  requestRemoteAccess: (_state) => { console.error('RemoteAccessContext needs a Provider.'); },
});

export const useRemoteAccess = (): RemoteAccessContextData => useContext(RemoteAccessContext);

export const RemoteAccessProvider: FC = ({ children }) => {
  const [remoteAccessEnabled, setRemoteAccessEnabled] = useState(false);

  const subscribe = useCallback(() => {
    mqtt_instance.getClient(function (client) {
      client.subscribe(REMOTE_ACCESS_TOPIC, new RegExp(`^${REMOTE_ACCESS_TOPIC}$`), (pTopic, pMessage) => {
        const isRemoteAccessEnabled = pMessage === true.toString();
        setRemoteAccessEnabled(isRemoteAccessEnabled);
      });
      client.subscribe(REMOTE_ACCESS_FAILED_TOPIC, new RegExp(`^${REMOTE_ACCESS_FAILED_TOPIC}$`), (pTopic, pMessage) => {
        messageBox(pMessage);
      });
    });
  }, []);

  const requestRemoteAccess = useCallback((remoteAccessEnabled: boolean) => {
    mqtt_instance.getClient((client) => client.publish(REMOTE_ACCESS_TOPIC, remoteAccessEnabled.toString(), true));
  }, []);

  useEffect(() => {
    window.addEventListener('mqttClientEvent', subscribe);
    return () => { window.removeEventListener('mqttClientEvent', subscribe); };
  }, []);

  return (
    <RemoteAccessContext.Provider
      value={{ remoteAccessEnabled, requestRemoteAccess }}>
      {children}
    </RemoteAccessContext.Provider>
  );
};
